import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
// import './assets/main.css'
import './assets/main-after.css'
import './assets/main-mobile.css'
import helpers from './helpers/format';
// import "@fontsource/poppins";
Vue.config.productionTip = false
window.helpers = helpers;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
